import { IShield } from '../../data/types/ship/shield/shield';
import { ShieldConfig } from '../../data/types/ship/shield/shield-config';
import { shieldConfigs } from './shield.configs';
import memoize from 'fast-memoize';

export const getShieldConfig = memoize(
  (shield: IShield): ShieldConfig => shieldConfigs[shield.type],
);
